import { Dispatch } from "redux";
import {
  NotificationDispatchType,
  SET_NOTIFICATION_UNREAD_COUNT,
} from "./NotificationActionType";

export const setNotificationUnradCount = (unreadCount: number) => (
  dispatch: Dispatch<NotificationDispatchType>
) => {
  try {
    dispatch({
      type: SET_NOTIFICATION_UNREAD_COUNT,
      payload: {
        unreadCount,
      },
    });
  } catch (e) {
    dispatch({
      type: SET_NOTIFICATION_UNREAD_COUNT,
      payload: {
        unreadCount: 0,
      },
    });
  }
};
